import { render, staticRenderFns } from "./paragraph.vue?vue&type=template&id=624238ca&"
import script from "./paragraph.vue?vue&type=script&lang=ts&"
export * from "./paragraph.vue?vue&type=script&lang=ts&"
import style0 from "./paragraph.vue?vue&type=style&index=0&id=624238ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
